import { useId } from 'react';
import clsx from 'clsx';
import { buildLabel } from '@1qa/shared';
import { Package } from '@/components/icons';
import { buildOptionLabel, type RunBuildState } from '@/lib/runBuild';
import { Select } from '@/components/ui';

/** "Build: Latest (2.4 (240))" choice next to Run buttons of mobile projects; hidden until a build is uploaded. */
export function RunBuildPicker({ state, className }: { state: RunBuildState; className?: string }) {
  const id = useId();
  if (!state.enabled || state.builds.length === 0) return null;
  const latest = state.builds[0]!;
  return (
    <div className={clsx('inline-flex items-center gap-2 text-sm', className)} title="Which app build runs install on the device">
      <label htmlFor={id} className="inline-flex items-center gap-1.5 text-xs font-medium tracking-label whitespace-nowrap text-fg-secondary uppercase">
        <Package className="size-3 text-primary" aria-hidden /> Build
      </label>
      <Select
        id={id}
        value={state.appBuildId ?? ''}
        onChange={(e) => state.setAppBuildId(e.target.value || null)}
        options={[
          { value: '', label: `Latest: ${buildLabel(latest)}` },
          ...state.builds.map((b) => ({ value: b.id, label: buildOptionLabel(b) })),
        ]}
        className="w-48 max-w-full"
      />
    </div>
  );
}
